var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MDCRipple } from '@material/ripple';
import Icon from './Icon';
/**
 * Button Component
 *
 *  @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/button.md
 *
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.componentDidMount = function () {
        if (!this.props.disableRipple && this.btnRef) {
            MDCRipple.attachTo(this.btnRef);
        }
    };
    Button.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.raised, raised = _c === void 0 ? false : _c, _d = _a.unelevated, unelevated = _d === void 0 ? false : _d, _e = _a.outlined, outlined = _e === void 0 ? false : _e, other = __rest(_a, ["label", "className", "raised", "unelevated", "outlined"]);
        var icon = (typeof this.props.icon === 'string')
            ? { icon: this.props.icon }
            : this.props.icon;
        var trailingIcon = (typeof this.props.trailingIcon === 'string')
            ? { icon: this.props.trailingIcon }
            : this.props.trailingIcon;
        return (React.createElement("button", __assign({ ref: function (el) { _this.btnRef = el || undefined; }, className: "madonna-button mdc-button" + (raised ? ' mdc-button--raised' : '') + (unelevated ? ' mdc-button--unelevated' : '') + (outlined ? ' mdc-button--outlined' : '') + " " + className, role: "button" }, other),
            icon && React.createElement(Icon, __assign({}, icon, { "aria-hidden": true })),
            label && React.createElement("span", { className: "mdc-button__label" }, label),
            trailingIcon && React.createElement(Icon, __assign({}, trailingIcon, { "aria-hidden": true }))));
    };
    // Used by react-styleguidist.
    Button.defaultProps = {
        disableRipple: false,
        raised: false,
        unelevated: false,
        outlined: false,
    };
    return Button;
}(React.Component));
export default Button;
//# sourceMappingURL=Button.js.map